import { Component, OnInit } from '@angular/core';
import { AbstractControl, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {
  form = new UntypedFormGroup(
    {
      newPassword: new UntypedFormControl('', [
        Validators.required,
        Validators.minLength(8)
      ]),
      confirmPassword: new UntypedFormControl('', [Validators.required])
    },
    {
      validators: (ac: AbstractControl) => {
        const g = ac as UntypedFormGroup;
        const np = g.get('newPassword')?.value;
        const cp = g.get('confirmPassword')?.value;
        return np && cp && np !== cp ? { passwordMismatch: true } : null;
      }
    }
  );
  token: string | null = null;
  message: string | null = null;
  success = false;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private authenticationService: AuthenticationService,
    private spinner: NgxSpinnerService
  ) {}

  ngOnInit(): void {
    this.token = this.route.snapshot.queryParamMap.get('token');
    if (!this.token || !this.token.trim()) {
      this.message = 'Link inválido. Solicite uma nova redefinição de senha.';
    }
  }

  isInvalid(control: AbstractControl): boolean {
    return !!(control && control.touched && control.dirty && !control.valid);
  }

  hasPasswordError(): boolean {
    const c = this.form.get('confirmPassword');
    return !!(c && c.touched && this.form.hasError('passwordMismatch'));
  }

  submit(): void {
    this.message = null;
    if (!this.token || !this.token.trim()) {
      this.message = 'Link inválido. Solicite uma nova redefinição de senha.';
      return;
    }
    if (!this.form.valid) {
      this.form.markAllAsTouched();
      return;
    }
    const newPassword = this.form.get('newPassword')?.value;
    if (!newPassword || newPassword.length < 8) {
      this.message = 'A senha deve ter no mínimo 8 caracteres, com letra maiúscula, número e caractere especial.';
      return;
    }
    this.spinner.show();
    this.authenticationService.resetPassword(this.token.trim(), newPassword).subscribe({
      next: () => {
        this.spinner.hide();
        this.success = true;
      },
      error: (err) => {
        this.spinner.hide();
        const msg = err?.error?.message || err?.message;
        this.message = msg || 'Não foi possível redefinir a senha. Tente novamente ou solicite um novo link.';
      }
    });
  }

  goToLogin(): void {
    this.router.navigate(['/login']);
  }
}
